
const digest = 'afd790aa94031eed79c6f15fc1912cb7e48c31a626a40ad8b0dc4923d6151cca';
const classes = {"wrapper":"_wrapper_66ess_1","quickAdjustmentWrapper":"_quickAdjustmentWrapper_66ess_7"};
const css = `._wrapper_66ess_1 {
  display: flex;
  flex-direction: row;
  margin: 0 -24px;
}

._quickAdjustmentWrapper_66ess_7 {
  flex-wrap: wrap;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  